import type { LoaderFunction } from 'react-router'
import * as z from 'zod/mini'
import i18n, { normalizeLanguage, type AppLanguage } from '../../i18n/configs'
import faq_ja_url from '../../assets/frequently_asked_questions.ja.json?url'
import faq_en_url from '../../assets/frequently_asked_questions.en.json?url'
import faq_ko_url from '../../assets/frequently_asked_questions.ko.json?url'
import privacy_policy_url from './assets/privacy_policy.txt?url'
import child_safety_policy_url from './assets/child_safety_policy.txt?url'
import tradelaw_url from '../../assets/tradelaw.txt?url'
import about_json_url from '../../assets/about.json?url'
import contact_txt_url from '../../assets/contact.txt?url'
import type { FAQ } from './faq-i18n'

const ImageWithContent = z.object({
  img: z.string(),
  title: z.string(),
  content: z.string(),
})
const AboutSchema = z.object({
  can_features: z.array(ImageWithContent),
  infomations: z.array(
    z.object({
      date: z.coerce.date(),
      title: z.string(),
      content: z.string(),
    })
  ),
  concepts: z.array(ImageWithContent),
  team: z.array(
    z.object({
      img: z.string(),
      name: z.string(),
      job: z.string(),
    })
  ),
})
export type ImageWithContent = z.infer<typeof ImageWithContent>
export type AboutSchema = z.infer<typeof AboutSchema>

const faq_urls = {
  ja: faq_ja_url,
  en: faq_en_url,
  ko: faq_ko_url,
} satisfies Record<AppLanguage, string>

export const getFaqUrl = (language: string | undefined) =>
  faq_urls[normalizeLanguage(language) || 'ja']

export const aboutLoader: LoaderFunction = () =>
  fetch(about_json_url).then(res=> res.json()).then(AboutSchema.parse)

export const faqLoader: LoaderFunction = () =>
  fetch(getFaqUrl(i18n.resolvedLanguage)).then(res=> res.json() as Promise<FAQ>)

export const privacypolicyLoader: LoaderFunction = () =>
  fetch(privacy_policy_url).then(res=> res.text())

export const childsafetyLoader: LoaderFunction = () =>
  fetch(child_safety_policy_url).then(res=> res.text())

export const tradelawLoader: LoaderFunction = () =>
  fetch(tradelaw_url).then(res=> res.text())

export const contactLoader: LoaderFunction = () =>
  fetch(contact_txt_url).then(res=> res.text())
